<div class="astrea-authors p-sm-4 p-2">
    <div class="container">

        <div class="astrea-title">
            <h1 class="mb-4">{{ 'pages.authors.title' | translate }}</h1>
        </div>

        <div class="astrea-alphabet mb-4">
            <div class="d-flex j-c-center j-c-sm-around a-i-center flex-wrap">
                <a *ngFor="let abc of alphabet" [routerLink]="['/authors']" [queryParams]="{ letter: abc }"
                    [ngClass]="filters.letter == abc ? 'active' : ''" [title]="('pages.authors.title' | translate) + ' ' + abc"
                >
                    {{ abc }}
                </a>
            </div>
        </div>

        <form [formGroup]="formSearch">
            <mat-form-field class="w-25 mr-3" appearance="fill">
                <mat-label>{{ 'pages.authors.search' | translate }}</mat-label>
                <input type="text" matInput formControlName="author">
            </mat-form-field>
            <button *ngIf="!loading" (click)="getSearch()" class="btn btn-green" mat-button>
                {{ 'search.search' | translate }}
            </button>
            <button *ngIf="loading" class="btn btn-green" mat-button>
                <astrea-loading></astrea-loading>
            </button>
            <button (click)="resetSearcher()" class="btn btn-reset ml-2" mat-button>
                Reset
            </button>
        </form>

        <div *ngIf="!loading; else astreaLoading">

            <ul *ngIf="authors && authors.length > 0; else withoutResults" class="p-0">
                <li *ngFor="let a of authors" class="astrea-author-item animated astreaFade">
                    <a [routerLink]="['/author', a.authorcode]" title="{{ a.lastname | uppercase }}, {{ a.firstname }}" class="d-flex j-c-start a-i-center py-2">
                        <div class="d-flex flex-column">
                            <h2>{{ a.lastname | uppercase }}, {{ a.firstname }}</h2>
                            <p>{{ 'pages.authors.count' | translate }}: {{ a.sizeDoctrines }}</p>
                        </div>
                    </a>
                </li>
            </ul>

            <ng-template #withoutResults>
                <div class="t-center">
                    {{ 'pages.authors.without' | translate }}
                </div>
            </ng-template>

            <!-- Escodemos paginador para el buscador por palabra, si no se rompe (NOV 2024) -->
            <div *ngIf="!filters.author">
                <astrea-paginator
                    [itemsPerPage]="itemsPerPage"
                    [totalLength]="totalLength"
                    [pageRedirect]="'/authors'"
                ></astrea-paginator>
            </div>

        </div>

        <ng-template #astreaLoading>
            <astrea-loading
                [text]="'pages.authors.loading' | translate"
            ></astrea-loading>
        </ng-template>

    </div>
</div>
